import { Button, IconPanorama36016 } from '@cian/ui-kit';
import styles from './PanoramaPreview.css';
import { FC } from 'react';

interface IPanoramaPreviewProps {
  onClick: VoidFunction;
}

export const PanoramaPreview: FC<IPanoramaPreviewProps> = ({ onClick }) => {
  return (
    <div className={styles['preview']} onClick={onClick}>
      <div className={styles['inner']}>
        <Button theme="fill_white_primary" beforeIcon={<IconPanorama36016 color="primary_100" />} size="M">
          Смотреть панораму
        </Button>
      </div>
    </div>
  );
};
